import { render, staticRenderFns } from "./L01Box3D.vue?vue&type=template&id=71e3de1e&"
import script from "./L01Box3D.vue?vue&type=script&lang=js&"
export * from "./L01Box3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports